import { useEffect, useState } from "react";
import axios from "axios";

const API_BASE = "https://api.corfubarber.com";
const ADMIN_ENDPOINT = `${API_BASE}/bookings`;
const BOOK_ENDPOINT = `${API_BASE}/book`;
const AVAIL_ENDPOINT = `${API_BASE}/availability`;

export default function Admin() {
  const today = new Date().toISOString().split("T")[0];

  const [pin, setPin] = useState("");
  const [authorized, setAuthorized] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [bookings, setBookings] = useState([]);
  const [selectedDate, setSelectedDate] = useState(today);
  const [availableSlots, setAvailableSlots] = useState([]);

  const [manualName, setManualName] = useState("");
  const [manualTime, setManualTime] = useState("");
  const [manualEmail, setManualEmail] = useState("");
  const [manualPhone, setManualPhone] = useState("");

  const headers = { "x-admin-pin": pin };

  /* ===================== AUTH ===================== */

  const login = async () => {
    if (!pin) return setError("Enter PIN");

    setLoading(true);
    setError("");

    try {
      const res = await axios.get(ADMIN_ENDPOINT, { headers });
      setBookings(res.data);
      setAuthorized(true);
      loadAvailability(selectedDate);
    } catch {
      setError("Wrong PIN");
    } finally {
      setLoading(false);
    }
  };

  /* ===================== AVAILABILITY ===================== */

  const isPastDate = (dateStr) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const selected = new Date(dateStr);
  selected.setHours(0, 0, 0, 0);

  return selected < today;
};

const filterRealisticSlots = (dateStr, slots) => {
  if (!dateStr) return [];

  // Past day → nothing
  if (isPastDate(dateStr)) return [];

  const now = new Date();

  // Not today → return all
  const todayStr = now.toISOString().split("T")[0];
  if (dateStr !== todayStr) return slots;

  // Today → only future times
  return slots.filter((slot) => {
    const [h, m] = slot.split(":").map(Number);
    const slotTime = new Date();
    slotTime.setHours(h, m, 0, 0);

    return slotTime > now;
  });
};


  const loadAvailability = async (date) => {
    try {
      const res = await axios.get(
        `${AVAIL_ENDPOINT}?date=${date}`,
        { headers }
      );
      setAvailableSlots(filterRealisticSlots(date, res.data));
    } catch {
      setAvailableSlots([]);
    }
  };

  useEffect(() => {
    if (authorized) loadAvailability(selectedDate);
  }, [selectedDate]);

  /* ===================== BOOKINGS ===================== */

  const addBooking = async () => {
    if (!manualTime) return alert("Select time");

    try {
      await axios.post(
        BOOK_ENDPOINT,
        {
          date: selectedDate,
          time: manualTime,
          name: manualName || "Walk-in",
          phone: manualPhone || "—",
          email: manualEmail || "asdasd@random123.com"
        },
        { headers }
      );

      const res = await axios.get(ADMIN_ENDPOINT, { headers });
      setBookings(res.data);

      loadAvailability(selectedDate);

      setManualTime("");
      setManualName("");
    } catch {
      alert("Booking failed");
    }
  };

  const deleteBooking = async (id) => {
    if (!window.confirm("Delete booking?")) return;

    try {
      await axios.delete(`${ADMIN_ENDPOINT}/${id}`, { headers });
      setBookings((prev) => prev.filter((b) => b.id !== id));
      loadAvailability(selectedDate);
    } catch {
      alert("Delete failed");
    }
  };

  /* ===================== SORTED VIEWS ===================== */

  const todayBookings = bookings
    .filter((b) => b.date === today)
    .sort((a, b) => a.time.localeCompare(b.time));

  const futureBookings = bookings
    .filter((b) => b.date > today)
    .sort(
      (a, b) =>
        new Date(`${a.date}T${a.time}`) -
        new Date(`${b.date}T${b.time}`)
    );

  /* ===================== UI ===================== */

  if (!authorized) {
    return (
      <div style={loginWrapper}>
        <div style={loginBox}>
          <h2>Admin Login</h2>
          <input
            type="password"
            value={pin}
            onChange={(e) => setPin(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && login()}
            placeholder="PIN"
            style={input}
          />
          <button onClick={login} style={button}>
            {loading ? "Checking..." : "Login"}
          </button>
          {error && <p style={{ color: "#ff6b6b" }}>{error}</p>}
        </div>
      </div>
    );
  }

  return (
    <div style={page}>
      <h1>Admin – Availability</h1>

      {/* DATE */}
      <input
        type="date"
        min={new Date().toISOString().split("T")[0]}
        value={selectedDate}
        onChange={(e) => setSelectedDate(e.target.value)}
        style={input}
      />

      {/* AVAILABLE SLOTS */}
      <h2 style={{ color: "#4caf50" }}>Available Slots</h2>
      <div style={slots}>
        {availableSlots.length ? (
          availableSlots.map((t) => (
            <button
              key={t}
              onClick={() => setManualTime(t)}
              style={{
                ...slotBtn,
                background: manualTime === t ? "#c9a24d" : "#4caf50",
              }}
            >
              {t}
            </button>
          ))
        ) : (
          <p>Δεν υπάρχει διαθέσιμη ώρα.</p>
        )}
      </div>

      {/* MANUAL BOOKING */}
      <input
        type="text"
        placeholder="Name (optional)"
        value={manualName}
        onChange={(e) => setManualName(e.target.value)}
        style={input}
      />

      <input 
        type="tel"
        placeholder="Τηλέφωνο (optional)"
        value={manualPhone}
        onChange={(e) => setManualPhone(e.target.value)}
        style={input}
      />

      <input
        type="email"
        placeholder="Email (optional)"
        value={manualEmail}
        onChange={(e) => setManualEmail(e.target.value)}
        style={input}
      />

      <button onClick={addBooking} style={button}>
        Book Selected Slot
      </button>

      {/* TODAY */}
      <h2>Today Bookings</h2>

      {todayBookings.length === 0 ? (
        <p style={{ opacity: 0.7 }}>No bookings for today.</p>
      ) : (
        <div style={grid}>
          {todayBookings.map((b) => (
            <BookingCard key={b.id} b={b} onDelete={deleteBooking} />
          ))}
        </div>
      )}

      {/* FUTURE */}
      <h2 style={{ marginTop: 30 }}>Future Bookings</h2>

      {futureBookings.length === 0 ? (
        <p style={{ opacity: 0.7 }}>No future bookings.</p>
      ) : (
        <div style={grid}>
          {futureBookings.map((b) => (
            <BookingCard key={b.id} b={b} onDelete={deleteBooking} />
          ))}
        </div>
      )}

    </div>
  );
}

/* ===================== COMPONENTS ===================== */


const BookingCard = ({ b, onDelete }) => (
  <div style={card}>
    Ώρα:<strong> {b.time} </strong><br /><br />{b.date.slice(8, 10)}-{b.date.slice(5, 7)}-{b.date.slice(0, 4)}
    <div>{b.name}</div>
    <div>{b.phone}</div>
    <button onClick={() => onDelete(b.id)} style={deleteBtn}>
      Delete
    </button>
  </div>
);

/* ===================== STYLES ===================== */

const page = {
  minHeight: "100vh",
  background: "#121212",
  color: "#f5f5f5",
  padding: "40px 12%",
};

const loginWrapper = {
  minHeight: "100vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  background: "rgb(22, 22, 22)"
};

const loginBox = {
  background: "#1e1e1e",
  padding: "40px",
  borderRadius: "16px",
  width: "100%",
  maxWidth: "400px",
  textAlign: "center",
};

const input = {
  width: "100%",
  padding: "12px",
  marginBottom: "12px",
  background: "#222",
  color: "white",
  border: "1px solid #444",
  borderRadius: "8px",
};

const button = {
  width: "100%",
  padding: "12px",
  background: "#c9a24d",
  border: "none",
  borderRadius: "8px",
  fontWeight: "bold",
  cursor: "pointer",
};

const slots = {
  display: "flex",
  flexWrap: "wrap",
  gap: "10px",
  marginBottom: "20px",
};

const slotBtn = {
  padding: "10px 14px",
  border: "none",
  borderRadius: "8px",
  cursor: "pointer",
  fontWeight: "bold",
};

const grid = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))",
  gap: "16px",
};

const card = {
  background: "#1e1e1e",
  padding: "16px",
  borderRadius: "12px",
  marginBottom: "10px",
};

const deleteBtn = {
  marginTop: "10px",
  background: "#d32f2f",
  color: "white",
  border: "none",
  padding: "8px 14px",
  borderRadius: "8px",
  cursor: "pointer",
};
